<template>
     <div class="imgcode_box" v-if="status">
        <div class="imgcode_dialog">
          <div class='xxsy_imgcode_fixed'>
            <div class='imgDragAuthHolder'>
              <div class='reflectStage' id="reflectStage">
                <img class='bgimg' :src='bigImg' />
                <img class='reflectimg' :src='smallImg' :style="'left: '+leftpx+'px'" />
                <span class='iconfont reashImgcode' @click="reachImgcode">&#xe615;</span>
                <span class='loading_svg' v-if="loading_svg">
                  <img :src='loading' alt=''>
                </span>
              </div>
              <div class='dragBarHolder' id="dragBarHolder" ref="dragDiv">
                <span class='drag_text'>向右拖动滑块填充拼图</span>
                <span class='right_bg_box' :style="'width:'+leftpx+'px'"></span>
                <div id='imgcode_draggable' class='imgcode_draggable ui-widget-content iconfont' @mousedown="mouseDownFn" @touchstart="mouseDownFn" :class="{ handler_ok_bg: confirmSuccess }" ref="moveDiv" :style="'left: '+leftpx+'px'">&#xe83e;</div>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
  import apiList from "@/http/api";
  export default {
    components: {

    },
    props:{
      status:{
        type:Boolean,
        default:false,
      }
    },
    data() {
      return {
        imgCodeWidth: '',
        loading: require('@/assets/images/loading-spin.svg'),

        beginClientX: 0 /*距离屏幕左端距离*/ ,
        mouseMoveState: false /*触发拖动状态  判断*/ ,
        maxWidth: "" /*拖动最大宽度，依据滑块宽度算出来的*/ ,
        confirmSuccess: false /*验证成功判断*/ ,

        leftpx: 0,
        uuid:'',//uuid
        color: {
          error: "#E41F1F",
          hua: "#005fff",
          ok: "#0baf23",
        }, //滑动按钮样式
        hoverStatus: true, //hover是否可以执行
        bigImg: '', //大图地址
        smallImg: '', //小图地址
        loading_svg: true, //刷新loading
      };
    },
    mounted() {
      var _this = this;
      document.getElementById("dragBarHolder").addEventListener("mousemove", this.mouseMoveFn);
      document.getElementById("dragBarHolder").addEventListener("mouseup", this.moseUpFn);
      document.getElementById("dragBarHolder").addEventListener("touchmove", this.mouseMoveFn);
      document.getElementById("dragBarHolder").addEventListener("touchend", this.moseUpFn);

      document.getElementById("imgcode_draggable").addEventListener("mousemove", this.mouseMoveColor);
      document.getElementById("imgcode_draggable").addEventListener("mouseout", this.mouseupColor);
      _this.initPage();
    },
    methods: {
      closeBtn() {
        this.tan = false;
        this.$emit("closeDuihuan", 0);
      },
      mouseMoveColor() {
        if (this.color.hua == '') {
          return false;
        }
        if (!this.hoverStatus) {
          return false
        }
        document.getElementsByClassName("right_bg_box")[0].style.backgroundColor = this.color.hua;
        document.getElementsByClassName("imgcode_draggable")[0].style.backgroundColor = this.color.hua;

      },
      mouseupColor() {
        if (this.color.hua == '') {
          return false;
        }
        if (!this.hoverStatus) {
          return false
        }
        document.getElementsByClassName("right_bg_box")[0].style.backgroundColor = this.color.hua;
        document.getElementsByClassName("imgcode_draggable")[0].style.backgroundColor = '#FFFFFF';
      },
      reachImgcode() {
        this.loading_svg = true;
        this.leftpx = 0;
        this.hoverStatus = true;
        this.confirmSuccess = false;
        document.getElementsByClassName("imgcode_draggable")[0].innerHTML = "&#xe617;";
        document.getElementsByClassName("imgcode_draggable ")[0].style = '';
        document.getElementsByClassName("imgcode_draggable ")[0].style.left = 0;
        document.getElementsByClassName("dragBarHolder")[0].classList.remove("noDra");
        this.initPage();
      },
      initPage() {
        var _this = this;
        this.maxWidth = this.$refs.dragDiv.clientWidth - this.$refs.moveDiv.clientWidth;
        this.imgCodeWidth = document.getElementById("reflectStage").offsetWidth;
        apiList.VerifyimgHua({
          width: _this.imgCodeWidth,
          callbacktype: "json"
        }).then(
          (res) => {
            if (res.code == 200) {
              _this.bigImg = "data:image/gif;base64," + res.data.bgImg ;
              _this.smallImg = "data:image/gif;base64," + res.data.sliceImg ;
              _this.loading_svg = false;
              _this.uuid = res.data.uuid;
            } else {
              _this.$dialog.message.error(res.msg, {
                position: 'top-right'
              })
            }
          },
          function(res) {
            _this.$dialog.message.error(res.msg, {
              position: 'top-right'
            })
          }
        );
      },
      //mousedown 事件
      mouseDownFn: function(e) {
        if (!this.confirmSuccess) {
          e.preventDefault && e.preventDefault(); //阻止文字选中等 浏览器默认事件
          this.mouseMoveState = true;
          this.beginClientX = e.clientX ? e.clientX : e.changedTouches[0].clientX;

        }
      },
      //验证成功函数
      successFunction() {

      },
      //mousemove事件
      mouseMoveFn(e) {
        if (this.mouseMoveState) {
          let numX = e.clientX ? e.clientX : e.changedTouches[0].clientX
          let width = numX - this.beginClientX;
          if (width > 0 && width <= this.maxWidth) {
            this.leftpx = width;
          } else if (width > this.maxWidth) {
            this.successFunction();
          }
        }
      },
      //mouseup事件
      moseUpFn(e) {
        var _this = this;
        if (_this.leftpx == 0) {
          return false;
        }
        this.mouseMoveState = false;
        this.hoverStatus = false;
        var code = Math.ceil(_this.leftpx / _this.imgCodeWidth * 100);
        if (_this.leftpx < this.maxWidth) {
          _this.$emit("backfun", {
            code: code,
            uuid: _this.uuid,
          });
          return false;
          apiList.VerifyimgValid({
            code: code,
            uuid: _this.uuid,
          }).then(
            (res) => {
              if (res.code == 200) {
                  if (_this.color.ok != '') {
                    document.getElementsByClassName("right_bg_box")[0].style.backgroundColor = _this.color.ok;
                    document.getElementsByClassName("imgcode_draggable")[0].style.backgroundColor = _this.color.ok;
                    document.getElementsByClassName("imgcode_draggable")[0].style.borderColor = _this.color.ok;
                  }
                  document.getElementsByClassName("imgcode_draggable")[0].innerHTML = "&#xe61e;";
                  document.getElementsByClassName("dragBarHolder")[0].classList.add("yesDra");
                  setTimeout(function() {
                    _this.$emit("backfun", {
                      code: code,
                      uuid: _this.uuid,
                    });
                  }, 500)
              } else {
                document.getElementsByClassName("imgcode_draggable")[0].innerHTML = "&#xe629;";
                document.getElementsByClassName("dragBarHolder")[0].classList.add("noDra");
                if (_this.color.error != '') {
                  document.getElementsByClassName("right_bg_box")[0].style.backgroundColor = _this.color.error;
                  document.getElementsByClassName("imgcode_draggable")[0].style.backgroundColor = _this.color.error;
                  document.getElementsByClassName("imgcode_draggable")[0].style.borderColor = _this.color.error;
                }
                setTimeout(function() {
                  _this.reachImgcode();
                }, 500)
              }
            },
            function(res) {
              _this.$dialog.message.error(res.msg, {
                position: 'top-right'
              })
            }
          );
        }
      },
    }
  };
</script>
<style lang="less">
  @media (min-width: 750px) {
    .imgcode_box{
     width: 100vw;
      height: 100vh;
      background-color: rgba(0,0,0,0.6);
      position: fixed;
      z-index:999;
      top: 0px;
      left: 0px;

    //资源兑换弹框
    .imgcode_dialog {
      position: absolute;
      top: 40%;
      left: 50%;
      transform: translate(-50%, -50%);
      .xxsy_imgcode_fixed {
        .imgDragAuthHolder {
          width: 400px;
          margin: 0px auto;
          background-color: #FFF;
          padding: 20px;
          border-radius: 10px;
          overflow: hidden;

          .reflectStage {
            position: relative;
            width: 100%;
            min-height: 150px;
            clear: both;
            overflow: hidden;
            border-radius: 5px;
            margin-bottom: 20px;

            .bgimg {
              display: block;
              width: 100%;
            }

            .reflectimg {
              height: 100%;
              position: absolute;
              display: block;
              overflow: hidden;
              left: 0;
              top: 0px;
            }

            .reashImgcode {
              position: absolute;
              top: 15px;
              right: 15px;
              font-size: 26px;
              cursor: pointer;
              color: #FFF;
              z-index: 1;
              transition: all 0.3s;

              &:hover {
                transform: scale(1.1);
              }
            }

            .loading_svg {
              position: absolute;
              top: 0px;
              left: 0px;
              height: 100%;
              width: 100%;
              z-index: 2;
              background-color: rgba(0, 0, 0, 0.8);
              align-content: center;
              flex-flow: wrap;
              justify-content: center;
              display: flex;

              img {
                width: 40px;
                height: 40px;
              }
            }
          }

          .dragBarHolder {
            position: relative;
            width: 100%;
            height: 40px;
            margin: 0px auto;
            border: 1px solid #cccccc;
            border-radius: 3px;

            .right_bg_box {
              width: 0px;
              height: 100%;
              display: block;
              background-color: #1991FA;
              padding-right: 20px;
              opacity: 0.3;
              position: relative;
              z-index: 1;
              box-sizing: content-box;
            }

            .drag_text {
              position: absolute;
              z-index: 0;
              line-height: 38px;
              text-align: center;
              display: block;
              width: 100%;
              color: #999;
            }

            #imgcode_draggable {
              position: absolute !important;
              width: 40px;
              height: 38px;
              overflow: hidden;
              border: none;
              border-left: 1px solid #cccccc;
              border-right: 1px solid #cccccc;
              top: 0;
              left: 0;
              cursor: pointer;
              line-height: 38px;
              font-size: 24px;
              color: #999;
              background-color: #FFF;
              text-align: center;
              z-index: 2;

              &:hover {
                color: #FFF;
                background-color: #1991FA;
              }
            }

            &.noDra {
              .right_bg_box {
                background-color: #ff0000;
              }

              #imgcode_draggable {
                border-left: 1px solid #ff0000;
                border-right: 1px solid #ff0000;
                color: #FFF;
                background-color: #ff0000;

                &:hover {
                  color: #FFF;
                  background-color: #ff0000;
                }
              }
            }

            &.yesDra {
              .right_bg_box {
                background-color: #19d71f;
              }

              #imgcode_draggable {
                border-left: 1px solid #19d71f;
                border-right: 1px solid #19d71f;
                color: #FFF;
                background-color: #19d71f;

                &:hover {
                  color: #FFF;
                  background-color: #19d71f;
                }
              }
            }
          }
        }

      }
    }
    }
  }

  @media (max-width: 750px) {
    .imgcode_box{
      width: 100vw;
      height: 100vh;
      background-color: rgba(0,0,0,0.6);
      position: fixed;
      z-index:999;
      top: 0px;
      left: 0px;
    //资源兑换弹框
    .imgcode_dialog {
      z-index: 999;

      .xxsy_imgcode_fixed {
        .imgDragAuthHolder {
          width: 90%;
          margin: 0px auto;
          background-color: #FFF;
          padding: 0.3rem;
          border-radius: 0.2rem;
          overflow: hidden;
          position: absolute;
          top: 40%;
          left: 50%;
          transform: translate(-50%, -50%);

          .reflectStage {
            position: relative;
            width: 100%;
            min-height: 1rem;
            clear: both;
            overflow: hidden;
            border-radius: 0.1rem;
            margin-bottom: 0.2rem;

            .bgimg {
              display: block;
              width: 100%;
            }

            .reflectimg {
              height: 100%;
              position: absolute;
              display: block;
              overflow: hidden;
              left: 0;
              top: 0px;
            }

            .reashImgcode {
              position: absolute;
              top: 0.2rem;
              right: 0.2rem;
              font-size: 0.5rem;
              cursor: pointer;
              color: #FFF;
              z-index: 1;
              transition: all 0.3s;

              &:hover {
                transform: scale(1.1);
              }
            }

            .loading_svg {
              position: absolute;
              top: 0px;
              left: 0px;
              height: 100%;
              width: 100%;
              z-index: 2;
              background-color: rgba(0, 0, 0, 0.8);
              align-content: center;
              flex-flow: wrap;
              justify-content: center;
              display: flex;

              img {
                width: 0.6rem;
                height: 0.6rem;
              }
            }
          }

          .dragBarHolder {
            position: relative;
            width: 100%;
            height: 0.8rem;
            margin: 0px auto;
            border: 1px solid #cccccc;
            border-radius: 3px;

            .right_bg_box {
              width: 0px;
              height: 100%;
              display: block;
              background-color: #1991FA;
              padding-right: 0.2rem;
              position: relative;
              z-index: 1;
              opacity: 0.2;
            }

            .drag_text {
              position: absolute;
              z-index: 0;
              line-height: 0.8rem;
              text-align: center;
              display: block;
              font-size: 0.36rem;
              width: 100%;
              color: #999;
            }

            #imgcode_draggable {
              position: absolute !important;
              width: 0.8rem;
              height: 0.74rem;
              overflow: hidden;
              border: none;
              border-left: 1px solid #cccccc;
              border-right: 1px solid #cccccc;
              top: 0;
              left: 0;
              cursor: pointer;
              line-height: 0.76rem;
              font-size: 0.4rem;
              color: #999;
              background-color: #FFF;
              text-align: center;
              z-index: 2;

              &:hover {
                color: #FFF;
                background-color: #1991FA;
              }
            }

            &.noDra {
              .right_bg_box {
                background-color: #ffd0d0;
              }

              #imgcode_draggable {
                border-left: 1px solid #ff0000;
                border-right: 1px solid #ff0000;
                color: #FFF;
                background-color: #ff0000;

                &:hover {
                  color: #FFF;
                  background-color: none;
                }
              }
            }

            &.yesDra {
              .right_bg_box {
                background-color: #a7eba9;
              }

              #imgcode_draggable {
                border-left: 1px solid #19d71f;
                border-right: 1px solid #19d71f;
                color: #FFF;
                background-color: #19d71f;

                &:hover {
                  color: #FFF;
                  background-color: none;
                }
              }
            }
          }
        }

      }
    }
    }

  }
</style>
